import { createReducer, on } from '@ngrx/store';

import type { ILocalizationSettings } from '../../models/responses';
import { loadLocalizationSettingsSuccess } from './user-settings.actions';

export interface State {
  localSettings: ILocalizationSettings | null;
}

const initialState: State = {
  localSettings: null,
};

export const reducer = createReducer(
  initialState,
  on(loadLocalizationSettingsSuccess, (state: State, { settings }) => ({
    ...state,
    localSettings: settings,
  })),
);

export const getLocalSettings = (state: State) => state.localSettings;
